<template>
    <div class="container mt-50">
        <div class="titre" id="differentes_etapes">
            <h2 class="text-uppercase">
                <span class="span-background">
                    Notre méthodologie en 10 étapes :
                </span>
            </h2>
        </div>
        <div class="d-flex flex-column gap-3 steps">
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">1.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Identification des besoins en personnel</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed1 }">
                        <p>Le processus de recrutement commence par l'identification des besoins en personnel en
                            fonction de
                            la croissance de votre organisation, du remplacement de départs, de la création de nouveaux
                            postes, etc.
                        </p>
                        <p>
                            Cette étape implique souvent la collaboration entre les responsables des ressources humaines
                            et
                            les gestionnaires de chaque département.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded1 }"
                        @click="collapsedTextBodySteps(1)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed1 }"
                        @click="collapsedTextBodySteps(1)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">2.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Création de la description de poste</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed2 }">
                        <p>Une fois les besoins en personnel identifiés, nous allons rédiger une description de poste.
                            Cette
                            description inclut généralement les responsabilités du poste, les compétences et les
                            qualifications requises, le niveau d'expérience souhaité, la localisation du poste, la
                            rémunération, les avantages sociaux, etc.</p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded2 }"
                        @click="collapsedTextBodySteps(2)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed2 }"
                        @click="collapsedTextBodySteps(2)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">3.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Diffusion des offres d'emploi </h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed3 }">
                        <p>
                            Les offres d’emploi sont ensuite diffusées via divers canaux : tels que des sites web
                            d'emploi,
                            les réseaux sociaux, des agences partenaires, ou même en interne si votre organisation
                            favorise
                            la mobilité.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded3 }"
                        @click="collapsedTextBodySteps(3)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed3 }"
                        @click="collapsedTextBodySteps(3)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">4.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Collecte des candidatures</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed4 }">
                        <p>Les candidats intéressés soumettent leurs candidatures en réponse à l’annonce. Les CV,
                            lettres de
                            motivation et autres documents pertinents sont recueillis pour chaque candidat.</p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded4 }"
                        @click="collapsedTextBodySteps(4)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed4 }"
                        @click="collapsedTextBodySteps(4)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">5.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Présélection des candidats</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed5 }">
                        <p>
                            En tant que recruteur, nous passons en revue les candidatures pour sélectionner celles qui
                            correspondent le mieux aux critères du poste définis ensemble. Cette présélection peut
                            inclure
                            une première analyse des CV, des entretiens téléphoniques ou des évaluations préliminaires
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded5 }"
                        @click="collapsedTextBodySteps(5)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed5 }"
                        @click="collapsedTextBodySteps(5)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">6.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Entretiens</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed6 }">
                        <p>
                            Les candidats présélectionnés sont généralement invités à participer à un ou plusieurs
                            entretiens. Ces entretiens vont nous permettre d'évaluer les compétences, l'expérience, la
                            personnalité et la motivation des candidats.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded6 }"
                        @click="collapsedTextBodySteps(6)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed6 }"
                        @click="collapsedTextBodySteps(6)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">7.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Tests et évaluations </h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed7 }">
                        <p>
                            Dans certains cas, nous pouvons utiliser des tests de personnalité, de compétences, des
                            évaluations techniques ou des mises en situation pour évaluer les compétences spécifiques
                            nécessaires au poste.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded7 }"
                        @click="collapsedTextBodySteps(7)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed7 }"
                        @click="collapsedTextBodySteps(7)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">8.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Vérification des références</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed8 }">
                        <p>
                            Nous pouvons également contacter les références fournies par les candidats pour obtenir des
                            informations sur leur expérience passée et leur comportement professionnel.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded8 }"
                        @click="collapsedTextBodySteps(8)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed8 }"
                        @click="collapsedTextBodySteps(8)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">9.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Fiche de poste</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed9 }">
                        <p>
                            Dès que le candidat est sélectionné, une fiche de poste lui est présentée, qui comprend les
                            conditions de travail, la rémunération et d'autres détails.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded9 }"
                        @click="collapsedTextBodySteps(9)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed9 }"
                        @click="collapsedTextBodySteps(9)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div>
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber dix">10.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3>Intégration</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed10 }">
                        <p>
                            Une fois que le candidat a accepté l'offre d'emploi, il est intégré à l'entreprise, ce qui
                            implique généralement une période d'orientation et de formation pour faciliter son
                            adaptation au
                            nouvel environnement de travail. Nous le suivons tout au long de son parcours d’intégration.
                        </p>
                    </div>
                </div>
                <div>
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded10 }"
                        @click="collapsedTextBodySteps(10)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed10 }"
                        @click="collapsedTextBodySteps(10)"></nuxt-img>
                </div>
            </div>
        </div>
        <div class="titre" id="financement">
            <h2 class="text-uppercase pb-3">
                <span class="span-background">
                    Bilan d’intégration
                </span>
            </h2>
            <div class="mt-20 textTitre">
                <p class="pb-3">entre 3 et 6 mois après le recrutement, nous proposons un entretien tripartite
                    permettant de
                    mieux accompagner l’intégration du candidat.
                </p>
            </div>
        </div>
    </div>
</template>
<script setup>
const isCollapsed1 = ref(false)
const isCollapsed2 = ref(false)
const isCollapsed3 = ref(false)
const isCollapsed4 = ref(false)
const isCollapsed5 = ref(false)
const isCollapsed6 = ref(false)
const isCollapsed7 = ref(false)
const isCollapsed8 = ref(false)
const isCollapsed9 = ref(false)
const isCollapsed10 = ref(false)

const isExpanded1 = ref(false)
const isExpanded2 = ref(false)
const isExpanded3 = ref(false)
const isExpanded4 = ref(false)
const isExpanded5 = ref(false)
const isExpanded6 = ref(false)
const isExpanded7 = ref(false)
const isExpanded8 = ref(false)
const isExpanded9 = ref(false)
const isExpanded10 = ref(false)

const collapsedTextBodySteps = (number) => {
    switch (number) {
        case 1:
            isCollapsed1.value = !isCollapsed1.value
            isExpanded1.value = !isExpanded1.value
            break
        case 2:
            isCollapsed2.value = !isCollapsed2.value
            isExpanded2.value = !isExpanded2.value
            break
        case 3:
            isCollapsed3.value = !isCollapsed3.value
            isExpanded3.value = !isExpanded3.value
            break
        case 4:
            isCollapsed4.value = !isCollapsed4.value
            isExpanded4.value = !isExpanded4.value
            break
        case 5:
            isCollapsed5.value = !isCollapsed5.value
            isExpanded5.value = !isExpanded5.value
            break
        case 6:
            isCollapsed6.value = !isCollapsed6.value
            isExpanded6.value = !isExpanded6.value
            break
        case 7:
            isCollapsed7.value = !isCollapsed7.value
            isExpanded7.value = !isExpanded7.value
            break
        case 8:
            isCollapsed8.value = !isCollapsed8.value
            isExpanded8.value = !isExpanded8.value
            break
        case 9:
            isCollapsed9.value = !isCollapsed9.value
            isExpanded9.value = !isExpanded9.value
            break
        case 10:
            isCollapsed10.value = !isCollapsed10.value
            isExpanded10.value = !isExpanded10.value
            break
    }

}
</script>
<style scoped>
.ul-position {
    padding: 20px 50px;
    gap: 1rem;
    color: var(--accent, #25233E);

    /* txt */
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}

.titre {
    border-radius: 30px;
    border: 3px solid var(--secondaire, #FAB74B);
    padding: 60px 50px;
}

h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
    text-align: center;
}

.textTitre {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    text-align: center;
}

.textTitre p:nth-child(1),
.textTitre p:nth-child(4) {
    /* h3 */
    font-family: Nunito;
    font-size: 34px;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
}

.textTitre p:nth-child(2) a {
    color: #318EC7;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    /* 27.93px */
    letter-spacing: 0.84px;
    text-decoration-line: underline;
}

.textTitre p:nth-child(3) {
    font-weight: 600;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    padding-left: 14rem;
    padding-right: 14rem;
}

.steps {
    margin: 0 5rem 0 5rem;
    overflow: hidden;
}

.stepItem {
    min-height: 120px;
    align-items: center;
}

.vr {
    top: -439%;
    left: 44%;
    background-color: #FAB74B;
    opacity: 1;
    width: 8px;
    min-height: 32em;
}

.stepNumber {
    font-family: Nunito;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
    position: absolute;
    top: 27%;
    left: 35%;
    z-index: 2;
}

.stepNumber.dix {
    left: 23%;
}

.bodyStep {
    width: 80%;
}

p {
    font-size: 18px;
}

ul {
    list-style-type: disc;
    padding-left: 2rem;
}

.textBodyStep,
.minus,
.expanded {
    display: none;
}

.collapsed {
    display: block;
}

.contact {
    column-gap: 1rem;
}

.fa-circle-info {
    font-size: 48px;
    color: #318EC7;
}

@media only screen and (min-width: 300px) and (max-width: 374px) {
    h3 {
        font-size: 20px !important;
    }

    .textTitre p {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .textTitre p:nth-child(2) a {
        font-size: 9px !important;
    }

    button-group a {
        width: 20% !important;
    }

    .contact {
        width: 100% !important;
    }

    .vr[data-v-9d194820] {
        top: -2000%;
        left: 45%;
        min-height: 150em;
    }

    .bodyStep h3 {
        margin-top: 0px;
        margin-left: 20px;
    }

    .stepNumber {
        font-size: 16px;
        top: 40%;
        left: 40%;
        z-index: 2;
    }

    .position-relative img,
    .btn-collapse img {
        min-width: 20px !important;
    }

    .btn-collapse img {
        position: unset;
        margin-left: -5px !important;
        width: 25px !important;
        margin-top: -10px;
    }

    .steps {
        margin: 0 0rem 0 0rem;
    }

    .bodyStep {
        width: 80%;
    }

    .ul-position {
        padding: 10px 10px;
        font-size: 14px;
        margin-left: 55px;
    }

    p {
        margin-bottom: 1rem;
        margin-top: 1rem;
        margin-left: 20px;
        line-height: 144%;
    }

    .titre {
        padding: 30px 10px;
    }
}

@media only screen and (min-width: 375px) and (max-width: 426px) {
    h3 {
        font-size: 20px !important;
    }

    .textTitre p {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .textTitre p:nth-child(2) a {
        font-size: 9px !important;
    }

    button-group a {
        width: 20% !important;
    }

    .contact {
        width: 100% !important;
    }

    .vr[data-v-9d194820] {
        top: -3532%;
        left: 34%;
        min-height: 150em;
    }

    .bodyStep h3 {
        margin-top: 10px;
        margin-left: 20px;
    }

    .stepNumber {
        font-size: 16px;
        top: 38%;
        z-index: 2;
        left: 33%;
    }

    .position-relative img {
        min-width: 20px !important;
    }

    .btn-collapse img {
        max-width: 25px !important;
    }

    .steps {
        margin: 0 0rem 0 0rem;
    }

    .bodyStep {
        width: 65%;
    }

    .position-relative img {
        max-width: 80%;
    }

    .ul-position {
        padding: 10px 10px;
        font-size: 14px;
        margin-left: 16px;
    }

    p {
        margin-bottom: 1rem;
        margin-top: 1rem;
        margin-left: 20px;
        line-height: 144%;
    }
}

@media only screen and (min-width: 501px) and (max-width: 768px) {
    h3 {
        font-size: 20px !important;
    }

    .ul-position {
        padding: 10px 10px;
        gap: 1rem;
        font-size: 14px;
    }
}


/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .container {
        max-width: 950px !important;
    }

    p {
        font-size: 18px !important;
    }

    ul li {
        font-size: 17px !important;
    }


}

@media only screen and (min-width: 938px) and (max-width: 1275px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}
</style>